import Dialog from "../../atoms/dialog";
import { useState } from 'react'
import DeleteRoutingRule from "../routing_rules/DeleteRoutingRule";

const DeleteRoutingRuleAlert = (props) => {
    const { onCompletion, rrdefId, onClose } = props; 
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        onClose()
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >        
        <DeleteRoutingRule  onCompletion={onCompletion} rrdefId={rrdefId} onClose={onClose} />
        </Dialog >
    )
}

export default DeleteRoutingRuleAlert;